import { render, staticRenderFns } from "./VerifyPass.vue?vue&type=template&id=b465603a&"
import script from "./VerifyPass.vue?vue&type=script&lang=js&"
export * from "./VerifyPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\Jatin\\Documents\\Source\\wiom-dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b465603a')) {
      api.createRecord('b465603a', component.options)
    } else {
      api.reload('b465603a', component.options)
    }
    module.hot.accept("./VerifyPass.vue?vue&type=template&id=b465603a&", function () {
      api.rerender('b465603a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/VerifyPass.vue"
export default component.exports